import './DisclosureStart.scss';

import { Box, Typography } from '@mui/material';
import { Button, InfoBox, Link } from '@huntington/honeycomb';
import { useNavigate } from 'react-router-dom';
import {
	DISCLOSURE_CONTINUE_BUTTON,
	DISCLOSURE_HEADER,
	DISCLOSURE_INFOBOX_MESSAGE,
	DISCLOSURE_REVIEW_SECTION_BODY,
	DISCLOSURE_REVIEW_SECTION_TITLE,
	DISCLOSURE_SAMPLE_DOCUMENT_LINK,
	DISCLOSURE_SUCCESS_SUBHEADER,
} from '../../../constants/messages';
import { ROUTE_DISCLOSURE_ACKNOWLEDGEMENT } from '../../../router/router';

export default function Disclosure() {
	const navigate = useNavigate();

	const handleContinue = () => {
		navigate(`../${ROUTE_DISCLOSURE_ACKNOWLEDGEMENT}`);
	};

	return (
		<>
			<Box className="outerTopBox">
				<Typography
					component="h1"
					variant="h1"
					sx={{ font: 'bold 2.25rem "Huntington Serif", serif' }}
				>
					{DISCLOSURE_HEADER}
				</Typography>

				<Box className="innerTopBox">
					<Typography className="cardIntro">{DISCLOSURE_SUCCESS_SUBHEADER}</Typography>

					<Box>
						<Typography className="sectionTitle">{DISCLOSURE_REVIEW_SECTION_TITLE}</Typography>
						<Typography className="cardText">{DISCLOSURE_REVIEW_SECTION_BODY}</Typography>
					</Box>
				</Box>
			</Box>

			<Box className="wrapperbox">
				{/* INFO BOX */}
				<InfoBox>
					<Typography className="calloutText">{DISCLOSURE_INFOBOX_MESSAGE}</Typography>

					{/* LINK ROW */}
					<Box className="docLinkRow">
						<Link className="docLink" href="#">
							{DISCLOSURE_SAMPLE_DOCUMENT_LINK}
						</Link>
					</Box>
				</InfoBox>

				{/* CONTINUE BUTTON */}
				<Box className="actionsRow">
					<Button onClick={handleContinue}>
						{DISCLOSURE_CONTINUE_BUTTON}
					</Button>
				</Box>
			</Box>
		</>
	);
}
